import { render } from "./PanelMantenimiento.vue?vue&type=template&id=5385b777&scoped=true"
import script from "./PanelMantenimiento.vue?vue&type=script&lang=js"
export * from "./PanelMantenimiento.vue?vue&type=script&lang=js"

import "./PanelMantenimiento.vue?vue&type=style&index=0&id=5385b777&lang=sass&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5385b777"]])

export default __exports__